import WebApp from '@twa-dev/sdk';

/**
 * Обёртка над @twa-dev/sdk. В dev-режиме (вне Telegram) initData пустой —
 * API вернёт 401. Для локальной разработки можно подложить mock через
 * VITE_MOCK_INIT_DATA в .env.
 */

export const tg = WebApp;

export function initTelegram(): void {
  try {
    WebApp.ready();
    WebApp.expand();
    WebApp.setHeaderColor('#0F1923');
    WebApp.setBackgroundColor('#0F1923');
    WebApp.enableClosingConfirmation();
  } catch {
    // вне Telegram — молча
  }
}

export function getInitData(): string {
  const mock = import.meta.env.VITE_MOCK_INIT_DATA as string | undefined;
  if (mock) return mock;
  return WebApp.initData ?? '';
}

export function getUser() {
  return WebApp.initDataUnsafe?.user;
}

export function haptic(style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft' = 'light'): void {
  try {
    WebApp.HapticFeedback.impactOccurred(style);
  } catch {
    /* noop */
  }
}

export function hapticNotif(type: 'success' | 'warning' | 'error' = 'success'): void {
  try {
    WebApp.HapticFeedback.notificationOccurred(type);
  } catch {
    /* noop */
  }
}

export function hapticSelection(): void {
  try {
    WebApp.HapticFeedback.selectionChanged();
  } catch {
    /* noop */
  }
}

export function showAlert(text: string): Promise<void> {
  return new Promise((resolve) => {
    try {
      WebApp.showAlert(text, () => resolve());
    } catch {
      window.alert(text);
      resolve();
    }
  });
}

export function showConfirm(text: string): Promise<boolean> {
  return new Promise((resolve) => {
    try {
      WebApp.showConfirm(text, (ok) => resolve(ok));
    } catch {
      resolve(window.confirm(text));
    }
  });
}

export function getThemeParams() {
  return WebApp.themeParams ?? {};
}

export function getColorScheme(): 'light' | 'dark' {
  return WebApp.colorScheme ?? 'dark';
}

export function getLanguage(): string {
  return WebApp.initDataUnsafe?.user?.language_code ?? 'en';
}
